import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import HeadMeta from '../components/HeadMeta';

export default function NotFound() {
  const { lang, t } = useLanguage();

  return (
    <>
      <HeadMeta 
        title={t('notFoundPage.title') || '404 - Siden blev ikke fundet'} 
        description={t('notFoundPage.message') || '404 - Siden blev ikke fundet på Captain Hurghada Tours.'}
      />

      <section className="min-h-screen pt-48 pb-20 bg-slate-950 text-white flex items-center justify-center text-center px-4">
        <div className="max-w-md mx-auto space-y-6">
          <div className="w-20 h-20 rounded-full bg-amber-500/10 border border-amber-500/30 text-amber-400 flex items-center justify-center text-3xl mx-auto shadow-xl">
            <i className="fa-solid fa-compass" aria-hidden="true" />
          </div>

          <span className="text-amber-400 font-bold text-sm uppercase tracking-widest block">
            {t('notFoundPage.badge') || 'Fejl 404'}
          </span>

          <h1 className="font-serif text-3xl sm:text-5xl font-bold tracking-tight">
            {t('notFoundPage.title')}
          </h1>

          <p className="text-slate-400 text-sm sm:text-base leading-relaxed">
            {t('notFoundPage.message')}
          </p>

          <div className="pt-4 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/"
              className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-amber-500 hover:bg-amber-600 text-slate-950 font-bold text-sm transition-colors shadow-md"
            >
              <span>{t('notFoundPage.homeBtn')}</span>
            </Link>
            <Link
              to="/oplevelser"
              className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-slate-900 border border-slate-700 text-white font-bold text-sm hover:bg-slate-800 transition-colors"
            >
              <span>{t('notFoundPage.expBtn')}</span>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
